import {CashBackStatus} from '../../../lendtech/cashBack/api/getCashBackCards/cashBackCards.types';

export type CashBackStatusWithLabel =
  | CashBackStatus.Active
  | CashBackStatus.Inactive
  | CashBackStatus.Expired;

export const statusTypeLabels: Record<CashBackStatusWithLabel, string> = {
  [CashBackStatus.Active]: 'فعال',
  [CashBackStatus.Inactive]: 'غیر فعال',
  [CashBackStatus.Expired]: 'منقضی شده',
};

export const isCashBackStatusWithLabel = (
  status?: CashBackStatus,
): status is CashBackStatusWithLabel =>
  status === CashBackStatus.Active ||
  status === CashBackStatus.Inactive ||
  status === CashBackStatus.Expired;
